import { TipoDocumento } from '@/shared/model/seguimiento/tipo-documento.model';

export enum EstadoDocumento {
  SIN_GENERAR = 'SIN GENERAR',
  GENERADO = 'GENERADO',
  FIRMADO = 'FIRMADO',
  SIN_REVISAR = 'SIN_REVISAR',
  ACEPTADO = 'ACEPTADO',
  RECHAZADO = 'RECHAZADO',
}

export interface IDocumento {
  contentType?: string | null;
  nombre?: string | null;
  size?: number | null;
  url?: string | null;
  contenido?: string | null;
  tipo?: TipoDocumento | null;
  estado?: EstadoDocumento | null;
  variant?: string | null;
  estadoActual?: string | null;
}

export class Documento implements IDocumento {
  constructor(
    public contentType?: string | null,
    public nombre?: string | null,
    public size?: number | null,
    public url?: string | null,
    public contenido?: string | null,
    public tipo?: TipoDocumento | null,
    public estado?: EstadoDocumento | null,
    public variant?: string | null,
    public estadoActual?: string | null
  ) {}

  static fromObject(data: IDocumento): Documento {
    const documento = new Documento();
    for (const [key, value] of Object.entries(data)) {
      documento[key] = value;
    }
    documento.variant = resolveEstadoDocumentoVariant(documento.estado);
    documento.estadoActual = obtenerValorEstadoDocumento(documento.estado);
    return documento;
  }
}

/**
 * La función que devuelve el valor del enum
 *
 * @param estado enum del estado
 * @return valor del enum
 */
export function obtenerValorEstadoDocumento(estado: EstadoDocumento): string {
  const estadoDocumentoValores: { [key: string]: string } = {
    SIN_GENERAR: 'SIN GENERAR',
    GENERADO: 'GENERADO',
    FIRMADO: 'FIRMADO',
    SIN_REVISAR: 'SIN REVISAR',
    ACEPTADO: 'ACEPTADO',
    RECHAZADO: 'RECHAZADO',
  };
  return estadoDocumentoValores[EstadoDocumento[estado]];
}

export default function resolveEstadoDocumentoVariant(estado: EstadoDocumento) {
  switch (estado) {
    case EstadoDocumento.SIN_GENERAR:
      return 'secondary';
    case EstadoDocumento.GENERADO:
      return 'success';
    case EstadoDocumento.SIN_REVISAR:
      return 'secondary';
    case EstadoDocumento.FIRMADO:
      return 'success';
    case EstadoDocumento.ACEPTADO:
      return 'primary';
    case EstadoDocumento.RECHAZADO:
      return 'danger';
    default:
      return 'light';
  }
}
